import React from 'react';
import { Field, EditView } from '@builtbypixel/nucleus';

import setup from './setup';
import {Box, Container} from "@chakra-ui/react";

const EditForm = () => {
  return (
    <EditView setup={setup} isFullWidth={false}>
      <Container
          p={{ base: '10px', sm: '15px' }}
          w='100%'
          variant='card'
          rounded='none'
          maxWidth='none'
      >
        <Box display='flex' flexDir='row' gridGap='3'>
            <Field auto isFullWidth name="url" component="text" label="Url *" isRequired />
            <Field auto isFullWidth name="h1" component="text" label="Page H1" isRequired />
        </Box>
          <Field auto isFullWidth name="meta_title" component="text" label="Meta Title" isRequired />
          <Field auto isFullWidth name="meta_description" component="richtext" label="Meta Description" isRequired />
      </Container>
    </EditView>
  );
};

export default EditForm;
